import { thumb, numberFormat, dateFormat } from '@/utils/util'

export const currency = function(number, decimals, dec_point, thousands_sep) {
  if (!decimals) {
    decimals = 2;
  }
  return '￥' + numberFormat(number, decimals, dec_point, thousands_sep);
}

export const thumbImg = function(url, width, height) {
  return thumb(url, width, height);
};

export const formatDate = function(date, format) {
  if (!date) {
    return '';
  }
  format = format || 'yyyy-MM-dd hh:mm:ss';
  return dateFormat(format, new Date(date.replace(/-/g, '/')));
};



// WEBPACK FOOTER //
// ./src/filter/index.js